export default "__VITE_ASSET__Dzmb5ZLx__"